<template>
  <!-- <div class="bk-container bk-personal_center clearfix"> -->
    <div class="wrapper">
      <div class="left-wrapper">
        <ul class="account-list list-box">
          <li>
            <router-link :to="basePath" exact>个人资料</router-link>
          </li>
          <li>
            <router-link :to="`${basePath}/social`">社交通讯</router-link>
          </li>
          <li>
            <router-link :to="`${basePath}/identity`">身份认证</router-link>
          </li>
          <li>
            <router-link :to="`${basePath}/privacy`">隐私设置</router-link>
          </li>
          <li>
            <router-link :to="`${basePath}/security`">安全设置</router-link>
          </li>
          <li>
            <router-link :to="`${basePath}/log`">登录日志</router-link>
          </li>
          <li>
            <router-link :to="`${basePath}/unbind`">注销账号</router-link>
          </li>
        </ul>
      </div>
      <div class="right-wrapper">
        <router-view></router-view>
      </div>
    </div>
  <!-- </div> -->
</template>
<script>
  export default {
      data () {
          return {
            basePath: '/s-mart/personal_center/profile'
          }
      },
      watch: {
        $route (val) {
          console.log(val);
        }
      },
      beforeDestroy(){
        console.log(this.$route);
      }
  }
</script>

<style media="screen" lang="scss">
  .bk-personal_center{
    .left-wrapper{
      width: 248px;
      float: left;
      .list-box{
        background: #fff;
        padding: 17px 0;
        text-align: center;
        li{
          height: 39px;
          color: #a6a6a6;
          line-height: 39px;
          cursor: pointer;
          a.active{
            background: #3a84ff;
            color: #fff;
          }
          a{
            color: #a6a6a6;
            width: 100%;
            display: inline-block;
          }
        }
      }
    }
    .right-wrapper{
      float: right;
      width: 911px;
      background: #fff;
      min-height: 779px;
    }
  }

</style>



// WEBPACK FOOTER //
// personal_profile.vue?8dda5b34